<template>
  <div id="finalScreen" class="finalScreen">
    <img class="bgImg bgImgRatio" :src="this.bgImg">

    <img class="topFlower" src="~@/../src/assets/images/finalScreen/flowerTop.png">
    <img class="bottomFlower" src="~@/../src/assets/images/finalScreen/flowerBottom.png">

<!--     <div class="containArea">
      
    </div> -->

<!--     <img class="finalLogo" src="~@/../src/assets/images/finalScreen/finalLogo.png">
      <img class="welcome" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/welcomeTC.png"> -->


    <div class="finalLogoArea">
      <img class="areaElement" src="~@/../src/assets/images/finalScreen/finalLogo.png">
    </div>
    <div class="welcomeTextArea">
      <img class="areaElement" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/welcomeTC.png">
      <img class="areaElement" v-if="this.language == 'EN'" src="~@/../src/assets/images/finalScreen/welcomeEN.png">
    </div>
    <div class="flowerArea">
      <img class="areaElement" src="~@/../src/assets/images/finalScreen/flower.png">
    </div>
    <div class="playIGTextAreaTc">
      <img class="areaElement" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/playIGTextTC.png">
    </div>
    <div class="playIGTextAreaEn">
      <img class="areaElement" v-if="this.language == 'EN'" src="~@/../src/assets/images/finalScreen/playIGTextEN.png">
    </div>
    

    <div class="playIGArea">
      <img class="areaElement touch" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/playIGTC.png" @mouseup.prevent="openIg" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openIg">
      <img class="areaElement touch" v-if="this.language == 'EN'" src="~@/../src/assets/images/finalScreen/playIGEN.png" @mouseup.prevent="openIg" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openIg">
    </div>
    <div class="exhibitionArea">
      <img class="areaElement touch" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/exhibitionTC.png" @mouseup.prevent="openExhibition" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openExhibition">
      <img class="areaElement touch" v-if="this.language == 'EN'" src="~@/../src/assets/images/finalScreen/exhibitionEN.png" @mouseup.prevent="openExhibition" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openExhibition">
    </div>
    <div class="ticketArea">
      <img class="areaElement touch" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/ticketTC.png" @mouseup.prevent="openTicketing" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openTicketing">
      <img class="areaElement touch" v-if="this.language == 'EN'" src="~@/../src/assets/images/finalScreen/ticketEN.png" @mouseup.prevent="openTicketing" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openTicketing">
    </div>
    <div class="replayArea touch">
      <img class="areaElement touch" @mouseup.prevent="replayJourney" v-if="this.language == 'TC'" src="~@/../src/assets/images/finalScreen/replayTC.png">
      <img class="areaElement touch" @mouseup.prevent="replayJourney" v-if="this.language == 'EN'" src="~@/../src/assets/images/finalScreen/replayEN.png">
    </div>


  </div>
</template>

<script>

import i18n from '@/language';
import { store } from '../store'
import base64Bg from '@/assets/images/base64/bg.js';
import * as commonFunction from '@/commonFunction/commonFunction'

export default {
  name: 'finalScreen',
  components: {
  },
  data () {
    return {
      language : i18n.locale,
      bgImg : base64Bg.data
    }
  },
  created(){
    if(commonFunction.isIOSwithChrome()){
      setTimeout(function(){
        var style = document.getElementById("finalScreen").getAttribute("style");
        if(style != null){
          var addStyle = style + "height:" + window.innerHeight + "px;";
        }
        else{
          var addStyle = "height:" + window.innerHeight + "px;";
        }
        document.getElementById("finalScreen").setAttribute("style",addStyle);
      },200)
    }
  },
  methods:{
    replayJourney(){
      store.state.isShowFinalScreen = false;
      store.state.replayJourneyEvent = true;
      gtag('event', 'Replay',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'page_view', { 
        'page_title': 'Video Page',
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk008+standard'
      });
    },
    openIg(){
      gtag('event', 'Invite Page IG Filter Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk006+standard'
      });
      window.open(store.state.igURL, "_blank"); 
    },
    openExhibition(){
      gtag('event', 'Invite Page Exhibition Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk00e+standard'
      });
      window.open(this.$t('exhibitionURL'), "_blank"); 
    },
    openTicketing(){
      gtag('event', 'Invite Page Ticketing Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk007+standard'
      });
      // var urlPath = "";
      // if(window.location.href.includes("/zh-hk")){
      //   urlPath = store.state.ticketingURL + "zh-hk/" + store.state.ticketingURLPath;
      // }else if(window.location.href.includes("/zh-cn")){
      //   urlPath = store.state.ticketingURL + "zh-cn/" + store.state.ticketingURLPath;
      // }else {
      //   urlPath = store.state.ticketingURL  + store.state.ticketingURLPath;
      // }
      window.open(this.$t('ticketingURL'), "_blank"); 
    }
  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
  },
}
</script>

<style scoped>
  .finalScreen{
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: calc(100% + 5px);
  }
  .bgImg{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }

  @media (max-aspect-ratio: 3360 / 1890){.bgImgRatio{min-width: 100%;max-height: 100%}}
  @media (min-aspect-ratio: 3360 / 1890){.bgImgRatio{max-width: 100%;min-height: 100%}}

  .topFlower{
    position: absolute;
    width: 95%;
    top: 20px;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .bottomFlower{
    position: absolute;
    width: 95%;
    bottom: 20px;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .containArea{
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    width: 100%;
    max-width: 50vmax;
    height: 100%;
    background-color: rgba(200,0,0,0.5);
  }

  .areaElement{
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .finalLogoArea{
    position: absolute;
    top: 40px;
    width: 100%;
    height: 12%;
  }
  .welcomeTextArea{
    position: absolute;
    top: calc(40px + 12% + 2%);
    width: 100%;
    height: 6%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .flowerArea{
    position: absolute;
    top: calc(40px + 12% + 2% + 6% + 2%);
    width: 100%;
    height: 2.5%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .playIGTextAreaEn{
    position: absolute;
    top: calc(40px + 12% + 2% + 6% + 2% + 2.5% + 2%);
    width: 100%;
    height: 38vw;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .playIGTextAreaTc{
    position: absolute;
    top: calc(40px + 12% + 2% + 6% + 2% + 2.5% + 4%);
    width: 100%;
    height: 28vw;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .playIGArea{
    position: absolute;
    top: calc(40px + 16% + 2% + 6% + 2% + 2.5% + 4% + 12% + 6%);
    width: 100%;
    height: 10%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .exhibitionArea{
    position: absolute;
    top: calc(40px + 16% + 2% + 6% + 2% + 2.5% + 4% + 12% + 6% + 10% + 1%);
    width: 100%;
    height: 10%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .ticketArea{
    position: absolute;
    top: calc(40px + 16% + 2% + 6% + 2% + 2.5% + 4% + 12% + 6% + 10% + 1% + 10% + 1%);
    width: 100%;
    height: 10%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .replayArea{
    position: absolute;
    top: calc(40px + 16% + 2% + 6% + 2% + 2.5% + 4% + 12% + 6% + 10% + 1% + 10% + 1% + 10% + 2% );
    width: 100%;
    height: 3.5%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

</style>



// WEBPACK FOOTER //
// src/components/finalScreen.vue